import { useCallback } from 'react';
import ReactGA from 'react-ga4';
export var useAnalytics = function useAnalytics() {
    var trackBookmark = useCallback(function (articleId, isBookmarked) {
        ReactGA.event({
            action: 'bookmark_article',
            category: 'engagement',
            label: articleId,
            value: isBookmarked ? 1 : 0
        });
    }, []);
    var trackPdfDownload = useCallback(function (articleId) {
        ReactGA.event({
            action: 'download_pdf',
            category: 'engagement',
            label: articleId
        });
    }, []);
    return {
        trackBookmark: trackBookmark,
        trackPdfDownload: trackPdfDownload
    };
};
